require('./cardReplaceSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

const CardReplaceSuccess = props => {
    const { immCard, immProfile } = props;
    const title = formatText('cardReplace-successMessage');
    const cardAlias = immCard.get('alias').get('current');
    const goBackButtonLabel = formatText('cardReplace-goToCard', [cardAlias]).toUpperCase();
    const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToDetails
    }
    const registeredAddress = PersonalDataHelper.getFormattedAddress(immProfile);

    return (
        <div className="card-replace-success col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardSuccess
                successMessage={title}
                mainButton={goBackButton}>
                <section className="card-replace-success__content row">
                    <div className="col-xs-6 col-md-7">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>

                    <div className="col-xs-6 col-md-5">
                        <FormattedText
                            value="cardReplace-messageWillSend"
                            className="card-replace-success__text"
                        />
                        <div className="card-replace-success__text card-replace-success__text--bold">
                            <i className="icon icon-s-locacion"></i> {registeredAddress}
                        </div>
                    </div>
                </section>
            </WizardSuccess>
        </div>
    );
};

CardReplaceSuccess.propTypes = {
    immCard: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired
};

module.exports = CardReplaceSuccess;